import { createAxiosThunk } from 'utils/reduxUtil'
import api from 'api/axios/foka'
import { initialState } from '../channelAddSlice'

const checkPcUrl = createAxiosThunk(
  'channelAdd/checkPcUrl',
  (noArgs, { getState }) =>
    api.channel.checkConnections(getState().channel.channelAdd.pcUrl)
)

checkPcUrl.reducers = builder => {
  builder.addCase(checkPcUrl.pending, state => {
    state.isPcUrlChecked = initialState.isPcUrlChecked
  })

  builder.addCase(checkPcUrl.fulfilled, state => {
    state.isPcUrlChecked = true
  })

  builder.addCase(checkPcUrl.rejected, (state, { payload }) => {
    state.isPcUrlChecked = true
    state.apiError = payload
  })
}

export default checkPcUrl
